import { createRoot, type Root } from "react-dom/client";
import Mm33 from "../pages/Mm33/Mm33";
import "../index.css";
import "../pages/Mm33/Mm33.custom.css";

let root: Root | null = null;

function mount(element: HTMLElement) {
  if (root) return;

  root = createRoot(element);
  root.render(<Mm33 />);
}

function unmount() {
  root?.unmount();
  root = null;
}

window.ACADMm33 = { mount, unmount };

function boot() {
  const element = document.getElementById("mm33-root");
  if (element) mount(element);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}
